<template>
    <div class="content-page">
        <div class="container-fluid add-form-list">
            <div class="row">
                <div class="col-sm-12">
                    <div class="card">
                        
                        <div class="card-body">
                            <ul class="nav nav-tabs" id="myTab" role="tablist">
                                <li class="nav-item" role="presentation">
                                    <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">Details</a>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <a class="nav-link" id="other-tab" data-toggle="tab" href="#other" role="tab" aria-controls="other" aria-selected="false" >Erreur</a>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <a class="nav-link" id="another1-tab" data-toggle="tab" href="#another1" role="tab" aria-controls="another1" aria-selected="false" >Succès</a>
                                </li>
                            </ul>
                            <div class="tab-content" id="myTabContent">
                                <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                                    <div class="col-lg-12">
                                        
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <label>Date d'enregistrement *</label>
                                                    <input type="text" :value="moment(user.created_at).format('DD  MMMM  YYYY HH:mm')" class="form-control" placeholder="XXXXXXXX" readonly>
                                                    <div class="help-block with-errors"></div>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                            <div class="form-group">
                                                <label>Nombre *</label>
                                                <input type="text" v-model="user.nombre" class="form-control" placeholder="Enter libelle" readonly>
                                                <div class="help-block with-errors"></div>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>Nombre de success *</label>
                                                <input type="text" v-model="user.success" class="form-control" placeholder="Enter libelle" readonly>
                                                <div class="help-block with-errors"></div>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>Nombre d'erreur *</label>
                                                <input type="text" v-model="user.error" class="form-control" placeholder="Enter card number" readonly>
                                                <div class="help-block with-errors"></div>
                                            </div>
                                        </div>
                                    </div>                            
                                    </div>
                                </div>
                                <div  class="tab-pane fade" id="other" role="tabpanel" aria-labelledby="other-tab">
                                    <div class="col-lg-12">
                                        <table id="example" class="data-table table mb-0 tbl-server-info">
                                            <thead class="bg-white text-uppercase">
                                                <tr class="ligth ligth-data">
                                                    <th>ligne</th>
                                                    <th>Nom & Prenom & Contact & CNI</th>
                                                    <th>Etat</th>
                                                </tr>
                                            </thead>
                                            <tbody class="ligth-body">
                                                <tr v-for="(recharge,index) in user.message_error" :key="index">
                                                    <td>{{ recharge.client.ligne}}</td>
                                                    <td>{{ recharge.client.name }} - {{ recharge.client.firstName }} - {{ recharge.client.contactPhone }} - {{ recharge.client.idNumber }}</td>  
                                                    <td v-if="recharge.error != null"> {{ recharge.error.error.message }} </td>  
                                                    <td v-else>You don't have permission to access this resource</td> 
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>                
                                </div>
                                <div  class="tab-pane fade" id="another1" role="tabpanel" aria-labelledby="another1-tab">
                                    <div class="col-lg-12">
                                        <table id="tickets" class="data-table table mb-0 tbl-server-info">
                                            <thead class="bg-white text-uppercase">
                                                <tr class="ligth ligth-data">
                                                    <th>#</th>
                                                    <th>Nom & prenoms</th>
                                                    <th>Contact</th>
                                                    <th>Adresse</th>
                                                    <th>CNI </th>
                                                </tr>
                                            </thead>
                                            <tbody class="ligth-body">
                                                <tr v-for="(ticket,index) in user.users" :key="index">
                                                    <td>{{ index + 1 }}</td>
                                                    <td>{{ ticket.nom }} {{ ticket.prenom }}</td>  
                                                    <td> {{ ticket.phone }} </td> 
                                                    <td> {{ ticket.adresse }} </td> 
                                                    <td > {{ ticket.numero_piece }}</td>   
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>    
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="vld-parent">
                        <loading :active.sync="isLoading" 
                        :can-cancel="true" 
                        :is-full-page="fullPage"></loading>
                    </div>
                </div>
            </div>
            <!-- Page end  -->
        </div>
    </div>
</template>
<script>
import axios from "axios";
import {URL_API} from '@/config'
// Import component
import Loading from 'vue-loading-overlay';
// Import stheet
import 'vue-loading-overlay/dist/vue-loading.css';
import Swal from 'sweetalert2'
import store  from '@/store'
import $ from "jquery"
import moment from 'moment'
moment.locale('fr')
export default {
    components: {
            Loading
    },
    data() {
        return {
            perms: [],
            permsi: [],
            user_perms: [],
            permissions: [],
            user:{},
            stored: store,
            packs:{},
            isLoading: false,
            fullPage: true,
            payload:{
                pack_id : null,
                montant : 0,
                user_id: this.$route.params.id
            },
            payload2:{
                permissions:[],
                user_id:null
            },
            initials: [],
            moment:moment
        };
    },
    mounted(){
        
        this.getUser()
    },
    methods:{
       
    
        getUser() {
            this.isLoading = true
            
            axios.get(URL_API+'auth/report/'+this.$route.params.id)
            .then(response => {
                console.log(response.data)
                if (response.data.status == true) {
                    $(document).ready( function () {
                            $('#tickets').DataTable(
                                {
                                    "lengthMenu": [ 5,10, 25, 50, 75, 100 ],
                                    "pageLength": 10,
                                    'order':[]
                                }
                            );
                        } );
                    $(document).ready( function () {
                            $('#example').DataTable(
                                {
                                    "lengthMenu": [ 5,10, 25, 50, 75, 100 ],
                                    "pageLength": 10,
                                    'order':[]
                                }
                            );
                        } );
                    this.user = response.data.data
                    this.user.message_error =  JSON.parse(this.user.message_error)
                    console.log(this.user)
                    this.isLoading = false
                }
            })
            .catch(error => {
                Swal.fire('Erreur', 'Une erreur s\'est produite lors de la récupération des données', 'error')
                console.log(error)
                this.errored = true
                this.isLoading = false
            })
        },
        
    }
}
</script>